import React, { memo, useEffect, useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import useInterval from '@use-it/interval';
import Scrollbars from 'react-custom-scrollbars';

import {
  MPLFNotifications,
  NotificationDetail,
  MPLFBadgeAllClear,
  MPLFRead,
  MPLFReadAll
} from '../modules/API';
import Cookies from '../modules/Cookies';
import { NativeClearNotificationsBadge } from '../modules/Native';
import { sleep } from '../modules/Utils';

let badgeCountCache = 0;
const setBadge = async (badge = 0) => {
  badgeCountCache = badge;
  $('.notiCountBadge').text(badge);
  $('.notiCountBadge')[badge ? 'show' : 'hide']();

  if (!badge) {
    NativeClearNotificationsBadge();
  }

  // NaviProfile is loaded async
  while ($('.naviNotiCountBadge').length < 1) {
    await sleep(300);
  }

  $('.naviNotiCountBadge').text(badge);
  $('.naviNotiCountBadge')[badge ? 'show' : 'hide']();
};
$(document).on('click', '.clearBadgeCount', async () => {
  if (badgeCountCache) {
    await MPLFBadgeAllClear({ session: Cookies.get('session') }).catch(e => {
      console.log(e);
      console.log('MPLFBadgeAllClearError');
    });
    setBadge();
  }
});

/**
 * @type {{
 *  senders: {
 *    [id: string]: {
 *      _id: string;
 *      nickname: string;
 *      icon_url: string;
 *    }
 *  },
 *  maps: {
 *    [id: string]: {
 *      _id: string;
 *      title: string;
 *      lang: {
 *        [locale: string] : {
 *          title: string;
 *        }
 *      }
 *    }
 *  },
 *  spots: {
 *    [id: string]: {
 *      _id: string;
 *      title: string;
 *      map_id: string;
 *      lang: {
 *        [locale: string] : {
 *          title: string;
 *        }
 *      }
 *    }
 *  },
 *  dialies: {
 *    [id: string]: {
 *      spot_id: string;
 *    }
 *  }
 * }}
 */
const detailDic = {
  senders: {},
  maps: {},
  spots: {},
  dialies: {}
};

const parseRelativeAndCalendarTime = date => {
  const today = moment();

  if (today.diff(date, 'h') < 22 * 1) {
    return date.fromNow();
  }

  if (today.diff(date, 'h') < 22 * 6) {
    return date.calendar();
  }

  return date.format('LL');
};

let offset = 0;
const limit = 20;
let fetching = false;

const NotiModalComponent = memo(() => {
  const [hasMore, setHasMore] = useState(true);
  const [notiDic, setNotiDic] = useState({});
  const notiList = useMemo(
    () =>
      _.chain(notiDic)
        .map(noti => noti)
        .orderBy(['created_at', 'id'], ['desc', 'desc'])
        .valueOf(),
    [notiDic]
  );

  useInterval(async () => {
    const { badge } = await MPLFNotifications({
      offset: 0,
      limit: 0,
      session: Cookies.get('session')
    });

    if (badgeCountCache !== badge) {
      // has new badge - reload all notifications
      offset = 0;
      setHasMore(true);
      setNotiDic({});
      fetchNotifications();
    }
  }, 5000);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    if (fetching || !hasMore) {
      return;
    }

    fetching = true;

    try {
      const { badge, notifications = {} } = await MPLFNotifications({
        offset,
        limit,
        session: Cookies.get('session')
      });

      setBadge(badge);
      offset += limit;

      const ids = Object.keys(notifications);
      if (ids.length < limit) {
        setHasMore(false);
      }

      const allIds = {
        sender_ids: [],
        map_ids: [],
        spot_ids: [],
        dialy_ids: []
      };

      for (const id of ids) {
        const noti = notifications[id];
        try {
          noti.id = id;
          noti.data = noti.data = JSON.parse(atob(noti.data));

          const { sender, map_id, spot_id, dialy_id } = noti.data;
          if (map_id) {
            if (!detailDic.maps[map_id]) {
              allIds.map_ids.push(map_id);
            }
          } else if (spot_id) {
            if (!detailDic.spots[spot_id]) {
              allIds.spot_ids.push(spot_id);
            }
          } else if (dialy_id) {
            if (!detailDic.dialies[dialy_id]) {
              allIds.dialy_ids.push(dialy_id);
            }
          }

          if (!detailDic.senders[sender]) {
            allIds.sender_ids.push(sender);
          }
        } catch (e) {
          console.log(e);
          delete notifications[id];
        }
      }

      for (const key of Object.keys(allIds)) {
        allIds[key] = _.uniq(allIds[key]);
      }

      if (
        allIds.sender_ids.length ||
        allIds.map_ids.length ||
        allIds.spot_ids.length ||
        allIds.dialy_ids.length
      ) {
        const detailResult = await NotificationDetail({
          session: Cookies.get('session'),
          locale: window.hlocale,
          ...allIds
        });

        _.forEach(detailResult, (collection, key) => {
          collection.forEach(obj => {
            detailDic[key][obj._id] = obj;
          });
        });
      }

      setNotiDic({
        ...notiDic,
        ...notifications
      });
    } catch (e) {
      console.log(e);
      console.log('MPLFNotificationsError');
    }

    fetching = false;
  };

  const openNoti = selectedId => async e => {
    e.preventDefault();
    const {
      id,
      open_at,
      data: { dialy_id, spot_id, map_id }
    } = notiDic[selectedId] || {};

    $('#NotiModal').addClass('freeze');

    try {
      if (!open_at) {
        await MPLFRead({
          session: Cookies.get('session'),
          notification_id: id
        });
      }

      let url = '/';

      if (map_id) {
        url = `/maps/archive/${map_id}`;
      } else if (spot_id) {
        url = `/maps/archive/${
          detailDic.spots[spot_id].map_id
        }/wall/spot-list/${spot_id}`;
      } else if (dialy_id) {
        url = `/maps/archive/${
          detailDic.spots[detailDic.dialies[dialy_id].spot_id].map_id
        }/wall/timeline/?post=${dialy_id}`;
      }

      window.location.href = url;
    } catch (error) {
      console.log(error);
      console.log('OpenNotiError');
      window.resolveLang('エラーが発生しました。');
      $('#NotiModal').removeClass('freeze');
    }
  };

  const renderNotiItems = () => {
    return notiList.map(notiObj => {
      const { id, data, open_at, created_at } = notiObj;

      if (!data) {
        return null;
      }

      const { type, sender, dialy_id, spot_id, map_id } = data;

      // nickname
      if (!detailDic.senders[sender]) {
        return null;
      }

      const { nickname, icon_url } = detailDic.senders[sender];
      let docType = '';
      let title = '';
      let spotTitle = '';
      let mapTitle = '';

      if (dialy_id) {
        if (!detailDic.dialies[dialy_id]) {
          return null;
        }

        const dialy = detailDic.dialies[dialy_id];

        if (!detailDic.spots[dialy.spot_id]) {
          return null;
        }
        title = spotTitle = window.resolveTranslated(
          detailDic.spots[dialy.spot_id],
          'title'
        );
        docType = window.resolveLang('記事');
      }

      if (spot_id) {
        if (!detailDic.spots[spot_id]) {
          return null;
        }
        const spot = detailDic.spots[spot_id];
        title = spotTitle = window.resolveTranslated(spot, 'title');

        if (!detailDic.maps[spot.map_id]) {
          return null;
        }
        mapTitle = window.resolveTranslated(
          detailDic.maps[spot.map_id],
          'title'
        );
        docType = window.resolveLang('スポット');
      }

      if (map_id) {
        if (!detailDic.maps[map_id]) {
          return null;
        }
        title = mapTitle = window.resolveTranslated(
          detailDic.maps[map_id],
          'title'
        );
        docType = window.resolveLang('マップ');
      }

      if (!notiTemplates.messages[type]) {
        return null;
      }

      let message = nickname
        ? notiTemplates.messages[type].hasName
        : notiTemplates.messages[type].noName;

      message = window.resolveLang(message, {
        nickname,
        docType,
        title,
        spotTitle,
        mapTitle
      });

      let profileImage = icon_url || '';
      if (profileImage) {
        profileImage = window.isUrl(profileImage)
          ? profileImage
          : `https://www.mljsv.com/beta/2ffc7af154cd9c098f7aa6346981b8fc7c359395658d3c6668d6c8560d9c3d96/${profileImage}%3Fsize%3D200`;
      }

      return (
        <a
          key={id}
          className={`notiListItem ${open_at ? '' : 'unread'}`}
          href="https://www.mplf.net/"
          onClick={openNoti(id)}
        >
          <div>
            <i
              className="isBackground"
              style={{
                backgroundImage: `url(${profileImage})`
              }}
            />
          </div>
          <div>
            <p
              dangerouslySetInnerHTML={{
                __html: message
              }}
            />
            <span>
              {parseRelativeAndCalendarTime(moment.utc(created_at).local())}
            </span>
          </div>
        </a>
      );
    });
  };

  return (
    <div className="modalInner">
      <div className="modalHead">
        <span
          onClick={() => {
            const hasUnreadNoti = _.find(notiDic, ({ open_at }) => !open_at);

            if (!hasUnreadNoti) {
              return;
            }

            MPLFReadAll({ session: Cookies.get('session') }).catch(e => {
              console.log(e);
              console.log('MPLFReadAllError');
            });

            _.forEach(notiDic, noti => {
              if (!noti.open_at) {
                noti.open_at = moment().format('YYYY-MM-DD HH-mm-ss');
              }
            });

            setNotiDic({
              ...notiDic
            });
          }}
        >
          {window.resolveLang('すべて既読にする')}
        </span>
        <p>{window.resolveLang('お知らせ')}</p>
        <i className="closeModal" />
      </div>
      <div className="modalBody">
        <Scrollbars
          autoHide
          style={{ height: '100%' }}
          onScroll={({ target: { scrollTop, scrollHeight, offsetHeight } }) => {
            if (scrollHeight - offsetHeight - scrollTop < 100) {
              fetchNotifications();
            }
          }}
        >
          <div className="notiListContainer">
            {renderNotiItems()}

            {hasMore && (
              <div className="skLoadingContainer">
                <div className="sk-fading-circle">
                  <div className="sk-circle1 sk-circle" />
                  <div className="sk-circle2 sk-circle" />
                  <div className="sk-circle3 sk-circle" />
                  <div className="sk-circle4 sk-circle" />
                  <div className="sk-circle5 sk-circle" />
                  <div className="sk-circle6 sk-circle" />
                  <div className="sk-circle7 sk-circle" />
                  <div className="sk-circle8 sk-circle" />
                  <div className="sk-circle9 sk-circle" />
                  <div className="sk-circle10 sk-circle" />
                  <div className="sk-circle11 sk-circle" />
                  <div className="sk-circle12 sk-circle" />
                </div>
              </div>
            )}

            {!hasMore && !notiList.length && (
              <p>{window.resolveLang('お知らせがありません。')}</p>
            )}
          </div>
        </Scrollbars>
      </div>
      <div className="skFadingCircleContainer">
        <div className="sk-fading-circle">
          <div className="sk-circle1 sk-circle" />
          <div className="sk-circle2 sk-circle" />
          <div className="sk-circle3 sk-circle" />
          <div className="sk-circle4 sk-circle" />
          <div className="sk-circle5 sk-circle" />
          <div className="sk-circle6 sk-circle" />
          <div className="sk-circle7 sk-circle" />
          <div className="sk-circle8 sk-circle" />
          <div className="sk-circle9 sk-circle" />
          <div className="sk-circle10 sk-circle" />
          <div className="sk-circle11 sk-circle" />
          <div className="sk-circle12 sk-circle" />
        </div>
      </div>
    </div>
  );
});

if (Cookies.get('session')) {
  ReactDOM.render(<NotiModalComponent />, document.getElementById('NotiModal'));
}

const notiTemplates = {
  messages: {
    good: {
      hasName:
        '<strong>{{nickname}}</strong>さんがあなたの<strong>{{title}}</strong>{{docType}}に<strong>いいね！</strong>しました。',
      noName:
        'あなたの<strong>{{title}}</strong>{{docType}}が<strong>いいね！</strong>されました。'
    },
    follow: {
      hasName:
        '<strong>{{nickname}}</strong>さんがあなたの<strong>{{title}}</strong>{{docType}}を<strong>フォロー</strong>しました。',
      noName:
        'あなたの<strong>{{title}}</strong>{{docType}}が<strong>フォロー</strong>されました。'
    },
    comment: {
      hasName:
        '<strong>{{nickname}}</strong>さんがあなたの<strong>{{title}}</strong>{{docType}}に<strong>コメント</strong>しました。',
      noName:
        'あなたの<strong>{{title}}</strong>{{docType}}に新しい<strong>コメント</strong>があります。'
    },
    createDialy: {
      hasName:
        '<strong>{{nickname}}</strong>さんが<strong>{{spotTitle}}</strong>スポットにチェックインしました。',
      noName:
        '<strong>{{spotTitle}}</strong>スポットにチェックインがありました。'
    },
    createSpot: {
      hasName:
        '<strong>{{nickname}}</strong>さんが<strong>{{mapTitle}}</strong>マップに<strong>{{spotTitle}}</strong>スポットを追加しました。',
      noName:
        '<strong>{{mapTitle}}</strong>マップに<strong>{{spotTitle}}</strong>スポットが追加されました。'
    }
  }
};
